module.exports = __webpack_public_path__ + "img/five.618a8957.png";